import { Grid, Paper, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';

const KnowAboutConclusion = ({ data, setResponseMessage }) => {
  const { setMessageData } = useMessageBox();
  const maxLength = data?.mensagemDigitosMaximo ?? 250;
  const minLength = data?.mensagemDigitosMinimo ?? 20;

  const [message, setMessage] = useState('');
  const [getErros, setErros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const saveForm = async (formData) => {
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/ConcluirAntecipacao', formData);
      setMessageData(response.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Mensagem enviada com sucesso!');
        setResponseMessage(response.data.resposta.mensagem);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      toast.error(error.response);
    }
    setIsLoading(false);
  };

  const handleSubmit = () => {
    const formData = {
      antecipacaoId: data?.antecipacaoId,
      ancoraId: data.ancoraId,
      antecipacaoCodigoAutenticacaoId: data.antecipacaoCodigoAutenticacaoId,
      fornecedorId: data.fornecedorId,
      fornecedorContaBancariaId: data.fornecedorContaBancariaId,
      dataAtualizacao: data.dataAtualizacao,
      codigoAutenticacaoDigitado: '0000',
      conclusao: data.conclusao,
      respostaDoFornecedor: message,
      fornecedoresContasBancarias: null,
      antecipacaoMotivoRecusaId: 0,
      origemAprovacao: data.origemAprovacao
    };
    saveForm(formData);
  };

  return (
    <S.RefuseContainer>
      <S.InfoContainer>
        <Grid container spacing={2} style={{padding:'10px'}}>
          <Grid item xs={12}>
            <Paper elevation={0} className="select-paper">
              <TextField
                multiline
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: maxLength, minLength: minLength }}
                helperText={`${
                  Number(data?.mensagemDigitosMaximo) - message.length
                } caracteres restantes`}
                onBlur={() => {
                  getErros.includes('Agencia') &&
                    setErros(getErros.filter((item) => item !== 'Agencia'));
                }}
              />
            </Paper>
            {message.length < minLength && (
              <S.ErrorMessage>Quantidade mínima de caracteres: {minLength}</S.ErrorMessage>
            )}
          </Grid>

          <Grid item xs={12} style={{ textAlign: 'left' }}>
            <S.ActionButton onClick={() => handleSubmit()} disabled={message.length < 20}>
              {isLoading ? 'Enviando...' : 'Enviar'}
            </S.ActionButton>
          </Grid>
        </Grid>
      </S.InfoContainer>
    </S.RefuseContainer>
  );
};

export default KnowAboutConclusion;
